<template>
  <v-card color="grey lighten-5">
    <v-layout row wrap>
      <v-toolbar class="baslik" size="120px" dark color="info">
        <v-toolbar-title class="baslikfont"> Cari Kartlar </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field :label="$t('current_index_searc_label')" flat="" solo-inverted="" hide-details append-icon="search"
          v-model="Query.q"></v-text-field>
        &nbsp;
        <v-tooltip bottom>
          <v-icon slot="activator" dark @click="filtrele()">filter_list</v-icon>
          <span>Arama Filtresi Ekle</span>
        </v-tooltip>


        <a target="_self" v-bind:href="'#/cari/yeni/'">
          <v-btn flat> <span class="hidden-sm-and-down">{{$t('current_index_addbuton_label')}} </span>
            <v-icon right dark>add_box</v-icon>
          </v-btn>
        </a>
        <v-menu offset-y>
          <v-btn slot="activator" dark icon>
            <v-icon>more_vert</v-icon>
          </v-btn>

          <v-list>
            <a target="_self" v-bind:href="'#/cari/tumkayitlar/'">
              <v-list-tile>
                <v-list-tile-title>{{$t('all_records')}}</v-list-tile-title>
              </v-list-tile>
            </a>
          </v-list>
        </v-menu>
      </v-toolbar>
      <v-layout row wrap>
        <v-container fluid="">
          <v-layout row="" wrap="">



            <v-flex  pa-1  xs12 sm6 md4 v-for="item in Currents" v-bind:key="item.index">
              <a target="_blank" v-bind:href="'#/cari/goster/'+item.Code">
                <v-card flat="" class="grey--text">
                  <v-layout>
                    <v-flex xs3>
                      <img v-show="item.MusteriTipi=='K'" height="95%" width="95%" style=" padding-left:10%; padding-top:10%;"
                        src="../../../assets/images/business.png">
                      <img v-show="item.MusteriTipi!='K'" height="95%" width="95%" style=" padding-left:15%; padding-top:15%;"
                        src="../../../assets/images/person.png">
                    </v-flex>
                    <v-flex xs9>

                      <v-card-title primary-title>
                        <v-list-tile-title>
                          <span class="body-1 red--text font-weight-bold">
                            {{item.Code}}
                          </span>
                        </v-list-tile-title>
                            <v-list-tile-title>
                          <span class="body-1 font-weight-bold">
                            {{item.Title}}
                          </span>
                        </v-list-tile-title>



                      </v-card-title>
                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-flex xs12 sm12>
                    <v-list>

                      <v-list-tile>
                        <v-list-tile-action>
                          <v-icon color="info">phone</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title> <span class="body-1 font-weight-light"> {{item.Phone}}</span>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider inset></v-divider>
                      <v-list-tile>
                        <v-list-tile-action>
                          <v-icon color="info">location_on</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <span class="body-1 font-weight-light"> {{item.Address}}</span>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-flex>
                </v-card>
              </a>
            </v-flex>
          </v-layout>
        </v-container>



        <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="500px">
          <v-card color="grey lighten-2">

            <v-card-title>Filtre Seçimi</v-card-title>
            <v-divider></v-divider>
            <v-card-text>

              <v-layout row="" wrap="">
                <div class="flex md12">
                  <v-autocomplete clearable="" label="Ana Hesap" append-icon="search" autocomplete :loading="loading"
                    :items="statecari" item-text="text" cache-items="" item-value="id" :search-input.sync="searchcari"></v-autocomplete>

                  <v-select :items="musteritipi" label="Müşteri Tipi" multiple item-text="text" item-value="value">

                  </v-select>

                  <v-select :items="hesapgurubu" hide-details="" label=" Hesap Gurubu" item-text="Adi" item-value="Kod"
                    max-height="400"></v-select>

                  <v-select :items="musteritipi" label="Cari Tip" item-text="text" item-value="value">
                  </v-select>

                  <v-select :items="masrafmerkezi" label="Masraf Merkezi" item-text="CodeName" item-value="Code">
                    <template slot="selection" slot-scope="{ item, index }">
                      <v-chip v-if="index === 0">
                        <h4> <span>{{ item.Code }}</span> </h4>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text caption">(+{{
                        EkstreHesap.IstenmeyenReferanslar.length - 1 }} diğer kayıt)</span>
                    </template>
                  </v-select>

                  <v-select :items="analiz" hide-details="" label=" Analiz Kodu" item-text="AnalizAdi" item-value="AnalizKod"
                    max-height="400"></v-select>





                  <!-- <div class="flex md6">
                                        <v-radio-group label="Acenta Bileti İçin" hide-details>
                                            <v-radio :value="0" label="Seçim Yok"></v-radio>
                                            <v-radio :value="1" label="Gelen Faturası Olan"></v-radio>
                                            <v-radio :value="2" label="Gelen Faturası Olmayan"></v-radio>
                                        </v-radio-group>
                                    </div> -->




                  <div class="flex md12">
                    <v-checkbox label="Hesap grup boş olanlar" hide-details=""></v-checkbox>
                    <v-checkbox label="Muhasebe kodu boş olanlar" hide-details=""></v-checkbox>
                    <v-checkbox label="Dış aktarım özel kodu boş olanlar" hide-details=""></v-checkbox>
                    <v-checkbox label="Dış aktarım muhasebe kodu boş olanlar" hide-details=""></v-checkbox>

                  </div>






                </div>
              </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click.native="dialogfiltre=false">İptal</v-btn>
              <v-btn color="blue darken-1" flat @click.native="filtrekayit()">Fİltrelerİ Uygula</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>


      </v-layout>

      <template>

        <template>
          <v-card>
            <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
              :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
              {{ text1 }}
              <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
            </v-snackbar>
          </v-card>
        </template>
      </template>
    </v-layout>
  </v-card>


</template>
<script>
  import imageler from '../../../assets/images/arkman.png'
  import auth from '../../../api/auth'
  export default {
    data() {
      return {
        searchcari: null,
        analiz: [],
        masrafmerkezi: [],
        hesapgurubu: [],
        statecari: [],
        musteritipi: [{
          text: 'Bireysel',
          value: 'B'
        }, {
          text: 'Kurumsal',
          value: 'K'
        }],
        dialogfiltre: false,
        tooltip: false,
        el: null,
        loading: false,
        items: [],
        search: null,
        kayitvarmi: false,
        Currents: [],
        progress: false,
        progress1: true,

        kayit: false,
        toplamkayit: 'Kayıt Listelenmedi...',
        kayitlar: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        Query: {
          q: '',
          c: ''
        }
      }
    },
    watch: {
      'Query.q': getCurrents,
      searchcari(val) {
        val && this.carigetir(val)
      }
    },
    methods: {
      getCurrents: getCurrents,
      filtrele: filtrele,
      carigetir: carigetir
    }
  }

  function filtrele() {

    this.dialogfiltre = true;
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.hesapgurubu = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.masrafmerkezi = response.body
    }, (response) => {
      if (response.status === 0) {
        console.log('ea')
      } else {
        console.log('ea')
      }
    })

    this.$http.post(auth.API_URL + 'api/Analysis/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.progress = false
      this.analiz = response.body
    }, (response) => {
      if (response.status === 0) {
        this.progress = false
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.progress = false
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })


  }


  function carigetir(v) {
    if (v.length >= 0) {
      this.loading = true
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/CurrentSearch', {
          q: escape(v)
        }, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.statecari = response.body
          this.Error = false
        }, (response) => {
          if (response.status === 0) {
            this.text = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text = 'Service Unavailable'
            this.snackbar = true
          }
        })
        this.loading = false
      }, 500)
    }
  }

  function getCurrents(e) {

  var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    this.kayitvarmi = false
    if (e.length >= 3) {
      this.progress = true
      this.progress1 = false

      this.Query.c=credentials.SirketKodu

      this.$http.post(auth.API_URL + 'api/Options/CurrentBoxSearch', this.Query, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.Currents = response.body
        this.toplamkayit = 'Toplam:' + response.body.length + ' adet kayıt listelendi...'

        if (response.body.length > 0) {
          this.kayitvarmi = true
        } else {
          this.kayitvarmi = false
          this.toplamkayit = 'Kayıt bulunamadı...'
        }
        this.kayit = false
        this.kayitlar = true
        this.progress = false
        this.progress1 = true
      }, (response) => {
        if (response.status === 0) {
          this.progress = false
          this.progress1 = true
          this.kayitvarmi = false

          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.Currents = []
          this.kayitvarmi = false

          this.kayit = true
          this.Error = response.statusText
        }
      })
    } else if (e.length === 0) {
      this.kayit = true
      this.kayitlar = false
      this.toplamkayit = 'Kayıt Yok'

      this.progress = false
      this.Currents = []
    } else {
      this.text1 = 'Service Unavailable'
      this.kayitlar = false
      this.toplamkayit = 'Kayıt Yok'
      this.progress = false
      this.Currents = []
    }
  }
</script>

<style>

</style>